// src/components/Questionnaire.jsx
import React, { useState } from 'react';
import { useMutation, useQuery } from '@apollo/client';
import { createAppointmentFix } from '../graphql/mutations';
import { LIST_USERS_LIMITED, listUsers } from '../graphql/queries'; // Import the correct queries
import './Questionnaire.css';

const Questionnaire = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    clientEmail: '',
    location: '',
    date: '',
    service: '',
    navigator: '',
    time: '',
    notes: '',
  });

  // Fetch navigators (use listUsersLimited for guest users)
  const { loading: navigatorsLoading, data: navigatorsData } = useQuery(LIST_USERS_LIMITED);

  console.log('navigatorsData', navigatorsData);
  const [createAppointment] = useMutation(createAppointmentFix, {
    refetchQueries: [{ query: LIST_USERS_LIMITED }], // Refetch after creating an appointment
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Prepare the input for the mutation
    const customer = `${formData.firstName.trim()} ${formData.lastName.trim()}`.toLowerCase();
    const input = {
      title: `Appointment for ${customer}`,
      customer,
      clientEmail: formData.clientEmail,
      location: formData.location,
      date: formData.date,
      recurrence: null,
      service: formData.service,
      navigator: formData.navigator,
      time: formData.time,
      duration: 30,
      notes: formData.notes,
      ModifiedBy: formData.clientEmail,
      status: 'created',
      reminder24Sent: false,
      reminder30Sent: false,
    };

    try {
      const { data } = await createAppointment({ variables: { input } });
      console.log('Appointment created:', data.createAppointmentFix);
      alert('Appointment scheduled successfully!');
      // Reset the form after successful submission
      setFormData({
        firstName: '',
        lastName: '',
        clientEmail: '',
        location: '',
        date: '',
        service: '',
        navigator: '',
        time: '',
        notes: '',
      });
    } catch (error) {
      console.error('Error creating appointment:', error);
      alert('Failed to schedule appointment. Please try again.');
    }
  };

  // Extract navigators from the query result
  const navigators = navigatorsData?.listUsersLimited || [];

  return (
    <div className="questionnaire-container">
      <h2>Schedule an Appointment</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label>First Name:</label>
          <input
            type="text"
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label>Last Name:</label>
          <input
            type="text"
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label>Email:</label>
          <input
            type="email"
            name="clientEmail"
            value={formData.clientEmail}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label>Location:</label>
          <select
            name="location"
            value={formData.location}
            onChange={handleChange}
            required
          >
            <option value="">Select a location</option>
            <option value="Location 1">Location 1</option>
            <option value="Location 2">Location 2</option>
            <option value="Location 3">Location 3</option>
          </select>
        </div>
        <div>
          <label>Date:</label>
          <input
            type="date"
            name="date"
            value={formData.date}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label>Service:</label>
          <select
            name="service"
            value={formData.service}
            onChange={handleChange}
            required
          >
            <option value="">Select a service</option>
            <option value="Service 1">Service 1</option>
            <option value="Service 2">Service 2</option>
          </select>
        </div>
        <div>
          <label>Navigator:</label>
          <select
            name="navigator"
            value={formData.navigator}
            onChange={handleChange}
            required
          >
            <option value="">Select a navigator</option>
            {navigators.map((navigator) => (
              <option key={navigator.id} value={navigator.id}>
                {navigator.name} {navigator.last_name}
              </option>
            ))}
            <option value="Any Navigator">Any Navigator</option>
          </select>
        </div>
        <div>
          <label>Time:</label>
          <select
            name="time"
            value={formData.time}
            onChange={handleChange}
            required
          >
            <option value="">Select a time</option>
            <option value="09:00">09:00 AM</option>
            <option value="10:00">10:00 AM</option>
            <option value="11:00">11:00 AM</option>
            <option value="13:00">01:00 PM</option>
            <option value="14:00">02:00 PM</option>
          </select>
        </div>
        <div>
          <label>Notes:</label>
          <textarea
            name="notes"
            value={formData.notes}
            onChange={handleChange}
            rows="3"
          />
        </div>
        <button type="submit">Schedule Appointment</button>
      </form>
    </div>
  );
};

export default Questionnaire;